import React, {Dispatch, SetStateAction, useCallback, useEffect, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {formatMoney} from "../model/moneyUtils";
import {ShareKeyType, TrackingTip, getRidePaymentReceiptUrl} from "../model/paymentApi";

interface TipsReceiptProps {
    tips: TrackingTip[];
    shareKey: string;
    shareKeyType: ShareKeyType;
    setAddMore: Dispatch<SetStateAction<boolean>>;
}

export function TipsReceipt({tips, shareKey, shareKeyType, setAddMore}: TipsReceiptProps) {
    const intl = useIntl();
    const [receiptUrl, setReceiptUrl] = useState("");

    const tipsSum = tips.reduce((acc, curr) => acc + parseInt(curr.price.amount), 0);
    const currency = tips[0].price.ccy;

    const fetchReceiptUrl = useCallback(async () => {
        try {
            const responseReceiptUrl = await getRidePaymentReceiptUrl(shareKeyType, shareKey);
            setReceiptUrl(responseReceiptUrl);
        } catch (error) {
            console.error("Failed to fetch receipt URL:", error);
        }
    }, [shareKeyType, shareKey]);

    useEffect(() => {
        fetchReceiptUrl();
    }, [tips, fetchReceiptUrl]);

    return (
        <div className="tip-receipt">
            <div>
                <FormattedMessage id="tip" /> {formatMoney({amount: tipsSum, ccy: currency}, intl)}
                {" · "}
                <button className="link-button" onClick={() => setAddMore(true)}>
                    <FormattedMessage id="add_more" />
                </button>
            </div>
            {receiptUrl && (
                <a href={receiptUrl} target="_blank" rel="noreferrer">
                    <FormattedMessage id="receipt" />
                </a>
            )}
        </div>
    );
}
